import { useEffect, useMemo } from 'react'
import VMasker from 'vanilla-masker';
import SearchUser from './SearchUser'
import { array as yupArray, object as yupObject, string as yupString } from 'yup'
import fetcher from '@byma/shared/helpers/fetcher'
import useAuth from '@byma/shared/hooks/useAuth'
import useForm from '@byma/shared/hooks/useForm'
import useSWR from 'swr'
import Loader from '@byma/shared/components/Loader'
import Input from '@byma/shared/components/Input'
import { FiTrash2 } from 'react-icons/fi'
import FormSection from '@byma/shared/components/FormSection'

export default function PartnerForm({ partner, onSubmit, isLoading=false }) {

    const session = useAuth()
    const { token } = session
    const today = useMemo(() => (new Date()).toISOString(), [])
    const { data: contracts, error } = useSWR(token ? ['/api/contracts/getAll?expires_at='+today, null, token] : null, fetcher)

    const { data: formData, setFieldValue, errors: formErrors, handleSubmit, resetErrors: resetFormErrors, getError } = useForm({
        initialValues: partner || { name: '', activeContract: '', users: [] },
        schema: yupObject().shape({
            name: yupString()
            .required('Nome é um campo obrigatório'),
            activeContract: yupString()
            .required('Contrato é um campo obrigatório'),
            users: yupArray()

        }),
        onSubmit: handleSave

    })

    useEffect(() => {
        if (contracts?.result?.length && !formData.activeContract) {
            console.log(contracts.result)
            setFieldValue('activeContract', contracts.result[0]._id)
        }
    }, [contracts])
    async function handleSave(values) {
        console.log('test', values)
        return onSubmit({
            ...values,
            users: formData.users.map(i => ({...i, userId: i.userId._id}))
        })
    }

    function renderError(key) {
        const error = getError(key)
        return error && <div className="error">{error}</div>
    }

    const handleAddUser = (user) => {
        if (!user) {
            return false
        }
        if (formData.users.map(userSelected => userSelected.userId._id).indexOf(user._id) >= 0) {
            return true
        }
        setFieldValue('users', [...formData.users, { userId: user, level: 'USER' }])
    }

    const handleRemoveUser = (user) => {
        console.log(formData.users, user)
        setFieldValue('users', formData.users.filter(userSelected => userSelected.userId._id !== user._id))
    }

    if ((partner && !partner.activeContract) && contracts && contracts.result.length === 0) {
        return <div>Nenhum contrato disponível</div>
    }

    return (
        <div className='flex flex-col space-y-6 p-3'>
            <FormSection
                title="Nome da equipe"
                infos={
                    <div className="flex flex-col space-y-3">
                        <p className="text-gray-800">
                            Defina o nome desta equipe.
                        </p>
                    </div>
                }
            >
                <Input error={getError('name')} onChange={e => setFieldValue('name', e.target.value)} type="text" name="name" label='Nome do time' value={formData.name} />
            </FormSection>

            { !partner && (
                <FormSection
                    title="Contrato"
                    infos={
                        <div className="flex flex-col space-y-3">
                            <p className="text-gray-800">
                                Selecione o contrato sob o qual esta equipe está associada.
                            </p>
                            <p className="text-gray-800">
                                Serão aplicadas as taxas e condições deste contrato para os eventos criados por esta equipe.
                            </p>
                        </div>
                    }
                >
                    {contracts ? (
                        <>
                            <select value={formData.activeContract} name="activeContract" className={`w-full p-4 ${getError('activeContract') && 'border-red-500'}`} onChange={(event) => setFieldValue('activeContract', event.target.value)}>
                                {contracts.result.map(contract => (
                                    <option id={contract._id} name={contract.name} className='w-full p-4' value={contract._id} >{contract.name}</option>

                                ))}
                            </select>
                            {renderError('activeContract')}
                        </>
                    ) : (
                        <Loader />
                    )}

                </FormSection>
            )}

            <FormSection
                title="Usuários associados"
                infos={
                    <div className="flex flex-col space-y-3">
                        <p className="text-gray-800">
                            Defina os membros participantes desta equipe.
                        </p>
                        <p className="text-gray-800">
                            Digite o e-mail do usuário e pressione enter para adicioná-lo a sua equipe.
                        </p>
                        <p className="text-gray-800">
                            Este e-mail deverá ser de um usuário cadastrado previamente no Byma.
                        </p>
                    </div>
                }
            >

                <SearchUser onSuccess={handleAddUser} />
                <div className="border rounded p-6 mb-6">
                    {formData.users.length > 0 ? (
                        <>
                            <div className="flex flex-col md:flex-row mb-3">
                                <div className="mb-3 md:mb-0 md:w-3/6">
                                    <p className="text-md tracking-tight">Usuário</p>
                                </div>
                                <div className="mb-3 md:mb-0 md:w-2/6 md:px-3">
                                    <p className="text-md tracking-tight">Nivel de acesso</p>
                                </div>
                                <div className="mb-3 md:mb-0 md:w-1/6 flex justify-end">
                                </div>
                            </div>
                            {formData.users.map(({ userId: user }, userIndex) => (
                                <div className="flex flex-col md:flex-row rounded border p-3 md:items-center mb-3">
                                    <div className="mb-3 md:mb-0 md:w-3/6">
                                        <p className="text-md">{user?.profile?.name}</p>
                                        <p className="text-sm text-gray-800">{user.email}</p>
                                    </div>
                                    <div className="mb-3 md:mb-0 md:w-2/6 md:px-3">
                                        <select className="px-3 py-2" onChange={(e) => setFieldValue(`users.${userIndex}.level`, e.currentTarget.value)} value={formData.users[userIndex].level}>
                                            <option value='ADMIN'>Administrador</option>
                                            <option value='USER'>Usuário</option>
                                        </select>
                                    </div>
                                    <div className="mb-3 md:mb-0 md:w-1/6 flex justify-end">
                                        <button onClick={() => handleRemoveUser(user)} className="btn btn-red">
                                            <FiTrash2 />
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </>
                    ) : (
                        <p className="text-center text-gray-800">
                            Nenhum usuário adicionado
                        </p>
                    )}
                </div>
            </FormSection>

            <div className='mt-5 w-full flex justify-center md:justify-end'>
                {isLoading ? (
                    <div>
                        <Loader />
                    </div>
                ) : (
                    <button className="btn btn-primary w-full" onClick={handleSubmit} disabled={isLoading}>
                        Salvar
                    </button>
                )}
            </div>

        </div>

    )
}
